export const NONCONSIGNORPERMISSIONS = {
  // Users
  getUsers: 'getUsers',
  addUser: 'addUser',
  editUser: 'editUser',
  deleteUser: 'deleteUser',

  // Roles
  getRoles: 'getRoles',
  addRole: 'addRole',
  editRole: 'editRole',
  deleteRole: 'deleteRole',

  // Masters & Dropdowns
  getHsns: 'getHsns',
  addHsn: 'addHsn',
  editHsn: 'editHsn',
  deleteHsn: 'deleteHsn',

  getUnits: 'getUnits',
  addUnit: 'addUnit',
  editUnit: 'editUnit',
  deleteUnit: 'deleteUnit',

  getPackings: 'getPackings',
  addPacking: 'addPacking',
  editPacking: 'editPacking',
  deletePacking: 'deletePacking',

  getCharges: 'getCharges',
  addCharge: 'addCharge',
  editCharge: 'editCharge',
  deleteCharge: 'deleteCharge',

  getConsignors: 'getConsignors',
  addConsignor: 'addConsignor',
  editConsignor: 'editConsignor',
  deleteConsignor: 'deleteConsignor',

  getNarrations: 'getNarrations',
  addNarration: 'addNarration',
  editNarration: 'editNarration',
  deleteNarration: 'deleteNarration',

  getContacts: 'getContacts',
  addContact: 'addContact',
  editContact: 'editContact',
  deleteContact: 'deleteContact',

  // Parties & Ledger
  getParties: 'getParties',
  addParty: 'addParty',
  editParty: 'editParty',
  deleteParty: 'deleteParty',
  verifyParty: 'verifyParty',
  viewPartyLedger: 'viewPartyLedger',

  // Generics
  getGenerics: 'getGenerics',
  addGeneric: 'addGeneric',
  editGeneric: 'editGeneric',
  viewGeneric: 'viewGeneric',
  deleteGeneric: 'deleteGeneric',
  restoreGeneric: 'restoreGeneric',

  // Materials & COAs
  getMaterials: 'getMaterials',
  addMaterial: 'addMaterial',
  editMaterial: 'editMaterial',
  deleteMaterial: 'deleteMaterial',
  restoreMaterial: 'restoreMaterial',
  addRawCOA: 'addRawCOA',
  addPackingCOA: 'addPackingCOA',
  addSecondaryPackingCOA: 'addSecondaryPackingCOA',
  addConsumableCOA: 'addConsumableCOA',

  // Products & Costing
  getProducts: 'getProducts',
  addProduct: 'addProduct',
  editProduct: 'editProduct',
  viewProduct: 'viewProduct',
  deleteProduct: 'deleteProduct',
  restoreProduct: 'restoreProduct',
  copyProduct: 'copyProduct',
  productFiles: 'productFiles',
  addBulkProductCOA: 'addBulkProductCOA',
  addFinishedProductCOA: 'addFinishedProductCOA',
  productCosting: 'productCosting',

  // SOPs
  getSops: 'getSops',
  addSop: 'addSop',
  editSop: 'editSop',
  deleteSop: 'deleteSop',

  // Machines
  getMachines: 'getMachines',
  addMachine: 'addMachine',
  editMachine: 'editMachine',
  deleteMachine: 'deleteMachine',

  // Transactions
  getTransactions: 'getTransactions',
  addTransaction: 'addTransaction',
  editTransaction: 'editTransaction',
  deleteTransaction: 'deleteTransaction',

  // Tasks, Checklists & Planned Scores
  getChecklists: 'getChecklists',
  addChecklist: 'addChecklist',
  editChecklist: 'editChecklist',
  deleteChecklist: 'deleteChecklist',
  getPlannedScores: 'getPlannedScores',
  addPlannedScore: 'addPlannedScore',
  editPlannedScore: 'editPlannedScore',
  deletePlannedScore: 'deletePlannedScore',
  getWeeklyMis: 'getWeeklyMis',

  // CRM / Leads
  getLeads: 'getLeads',
  addLead: 'addLead',
  editLead: 'editLead',
  deleteLead: 'deleteLead',
  assignLead: 'assignLead',
  getAllLeads: 'getAllLeads',
  getLeadOrigins: 'getLeadOrigins',
  addLeadOrigin: 'addLeadOrigin',
  editLeadOrigin: 'editLeadOrigin',
  deleteLeadOrigin: 'deleteLeadOrigin',

  // Order Operations & Dashboards
  getProductsToOrder: 'getProductsToOrder',
  updateMrp: 'updateMrp',
  updateRemark: 'updateRemark',
  editFormulationInProduction: 'editFormulationInProduction',
  deleteProductOrderFiles: 'deleteProductAndOrderFiles',
  orderDashboard: 'orderDashboard',
  notPunchedDashboard: 'notPunchedDashboard',
  ppicDepartmentDashboard: 'ppicDepartmentDashboard',
  accountDepartmentDashboard: 'accountDepartmentDashboard',
  qualityDepartmentDashboard: 'qualityDepartmentDashboard',
  productionDepartmentDashboard: 'productionDepartmentDashboard',

  // Reports
  saleFigures: 'saleFigures',
  saleReport: 'saleReport',
  purchaseFigures: 'purchaseFigures',
  salesMis: 'salesMis',
  soInvoiceComparison: 'soInvoiceComparison',
  lastSellingProductGpValues: 'lastSellingProductGpValues',
  onTimeDeliveryReport: 'onTimeDeliveryReport',
  onTimeReceivedReport: 'onTimeReceivedReport',
  yearlyDispatchReport: 'yearlyDispatchReport',
  orderFMS: 'orderFMS',
  orderMIS: 'orderMIS',
  getProductSaleReport: 'getProductSaleReport',
  getMaterialSaleReport: 'getMaterialSaleReport',
  getCoaReport: 'getCoaReport',
  userWiseOrdersReport: 'userWiseOrdersReport',
  getSaleInvoiceDues: 'getSaleInvoiceDues',
  getPurchaseInvoiceDues: 'getPurchaseInvoiceDues',
  userMIS: 'userMIS',
  manageOrderStageResponsibles: 'manageOrderStageResponsibles',
  procurementFMS: 'procurementFMS',
  vendorScorecard: 'vendorScorecard',
  purchasesWithoutTax: 'purchasesWithoutTax',
  salesWithoutTax: 'salesWithoutTax',
  yearlyPIFigures: 'yearlyPIFigures',
};

export const CONSIGNORPERMISSIONS = {
  // Purchase Orders & RFQs
  getPurchaseOrders: 'getPurchaseOrders',
  addPurchaseOrder: 'addPurchaseOrder',
  editPurchaseOrder: 'editPurchaseOrder',
  deletePurchaseOrder: 'deletePurchaseOrder',
  completePurchaseOrder: 'completePurchaseOrder',
  authorizePurchaseOrder: 'authorizePurchaseOrder',
  getRfqs: 'getRfqs',
  addRfq: 'addRfq',

  // Purchases & QC
  getPurchases: 'getPurchases',
  addPurchase: 'addPurchase',
  editPurchase: 'editPurchase',
  deletePurchase: 'deletePurchase',
  generateTestingSlips: 'generateTestingSlips',
  purchaseQC: 'purchaseQC',
  getMaterialsToOrder: 'getMaterialsToOrder',

  // Quotations & Proforma Invoices
  getQuotations: 'getQuotations',
  addQuotation: 'addQuotation',
  editQuotation: 'editQuotation',
  deleteQuotation: 'deleteQuotation',
  getProformaInvoices: 'getProformaInvoices',
  addProformaInvoice: 'addProformaInvoice',
  editProformaInvoice: 'editProformaInvoice',
  deleteProformaInvoice: 'deleteProformaInvoice',
  authorizeProformaInvoice: 'authorizeProformaInvoice',

  // Sale Orders
  getSaleOrders: 'getSaleOrders',
  addSaleOrder: 'addSaleOrder',
  editSaleOrder: 'editSaleOrder',
  deleteSaleOrder: 'deleteSaleOrder',
  completeSaleOrder: 'completeSaleOrder',

  // Inventory (Product & Material)
  getProductInventory: 'getProductInventory',
  adjustProductInventory: 'adjustProductInventory',
  transferProductInventory: 'transferProductInventory',
  getMaterialInventory: 'getMaterialInventory',
  adjustMaterialInventory: 'adjustMaterialInventory',
  transferMaterialInventory: 'transferMaterialInventory',

  // Orders & Production Workflow
  getOrders: 'getOrders',
  addOrder: 'addOrder',
  editOrder: 'editOrder',
  deleteOrder: 'deleteOrder',
  authorizeOrder: 'authorizeOrder',
  completeOrder: 'completeOrder',
  getBatchedOrder: 'getBatchedOrder',
  uploadOrderDesignChanges: 'uploadOrderDesignChanges',
  approveOrderDesignChanges: 'approveOrderDesignChanges',
  moveToProductionPlanning: 'moveToProductionPlanning',
  moveToSalePreparation: 'moveToSalePreparation',
  updateOrderOverage: 'updateOrderOverage',
  dispenseOrderMaterials: 'dispenseOrderMaterials',
  verifyRawMaterials: 'verifyRawMaterials',
  verifyOtherMaterials: 'verifyOtherMaterials',
  verifyFormulation: 'verifyFormulation',
  moveToProduction: 'moveToProduction',
  production: 'production',
  fillMfgExpDate: 'fillMfgExpDate',
  fillBMR: 'fillBMR',
  fillBPR: 'fillBPR',
  fillCOA: 'fillCOA',
  downloadProductionFiles: 'downloadProductionFiles',

  // Pre-Sales & Sales
  getPreSales: 'getPreSales',
  addPreSale: 'addPreSale',
  editPreSale: 'editPreSale',
  deletePreSale: 'deletePreSale',
  getSales: 'getSales',
  addSale: 'addSale',
  editSale: 'editSale',
  deleteSale: 'deleteSale',

  // Credit / Debit Notes (CDN)
  getCDNs: 'getCreditDebitNotes',
  addCDN: 'addCreditDebitNote',
  editCDN: 'editCreditDebitNote',
  deleteCDN: 'deleteCreditDebitNote',

  // Banking, Finance & Bills
  getBanks: 'getBanks',
  addBank: 'addBank',
  editBank: 'editBank',
  deleteBank: 'deleteBank',
  getBills: 'getBills',
  addBill: 'addBill',
  editBill: 'editBill',
  deleteBill: 'deleteBill',
  viewMaterialLedger: 'viewMaterialLedger',
  viewProductLedger: 'viewProductLedger',
  financeReports: 'financeReports',

  // Assets
  getAssets: 'getAssets',
  addAsset: 'addAsset',
  editAsset: 'editAsset',
  deleteAsset: 'deleteAsset',
  adjustAsset: 'adjustAsset',

  // Help Tickets
  getHelpTickets: 'getHelpTickets',
  addHelpTicket: 'addHelpTicket',
  editHelpTicket: 'editHelpTicket',
  deleteHelpTicket: 'deleteHelpTicket',
};

const PERMISSIONS = {
  ...NONCONSIGNORPERMISSIONS,
  ...CONSIGNORPERMISSIONS,
};

export default PERMISSIONS;
